var _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteModalCalendar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 5,
    width: 17,
    height: 15.5,
    rx: 2.5,
    stroke: "#1F2937",
    strokeWidth: 1.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 3v4M16 3v4M3.5 9.5h17",
    stroke: "#1F2937",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1F2937"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 13,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 13,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 13,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 17,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 17,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 17,
    r: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteModalCalendar);
export default __webpack_public_path__ + "static/media/delete-modal-calendar.8a4d4ef3bfd360c7e14a2ee76febe23f.svg";
export { ForwardRef as ReactComponent };